"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeletePreset = exports.usePatchPreset = exports.useSharePreset = exports.useGetListUserPreset = exports.useUpdatePreset = exports.useGetPreset = exports.useCreatePreset = exports.useGetListPreset = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_query_1 = require("react-query");
const ObjectiveAnalyticsClient_1 = require("client/ObjectiveAnalyticsClient");
const objectiveComparativeKeys_1 = __importDefault(require("consts/queryKeys/objectiveComparativeKeys"));
const useGetListPreset = (options) => {
    const fetchGetPreset = () => {
        return (0, ObjectiveAnalyticsClient_1.getListPreset)();
    };
    return (0, react_query_1.useQuery)(objectiveComparativeKeys_1.default.default, () => fetchGetPreset(), options);
};
exports.useGetListPreset = useGetListPreset;
const useCreatePreset = () => {
    return (0, react_query_1.useMutation)(async (body) => {
        const response = await (0, ObjectiveAnalyticsClient_1.createPreset)(body);
        if (response?.isSuccess) {
            return response;
        }
        throw response;
    });
};
exports.useCreatePreset = useCreatePreset;
const useGetPreset = (id, options) => {
    const fetchObjectiveComparative = () => {
        return (0, ObjectiveAnalyticsClient_1.getObjectiveComparative)(id);
    };
    return (0, react_query_1.useQuery)(objectiveComparativeKeys_1.default.preset(id, null), () => fetchObjectiveComparative(), options);
};
exports.useGetPreset = useGetPreset;
const useUpdatePreset = (id) => {
    return (0, react_query_1.useMutation)(async (body) => {
        const response = await (0, ObjectiveAnalyticsClient_1.updateObjectiveComparative)(id, body);
        if (response?.isSuccess) {
            return response;
        }
        throw response;
    });
};
exports.useUpdatePreset = useUpdatePreset;
// ** Will Be Used in Next Release **
const useGetListUserPreset = (params, options) => {
    const fetchGetUsers = (olderThan, signal) => {
        return (0, ObjectiveAnalyticsClient_1.getUsersSharingPreset)({ ...params, olderThan }, signal);
    };
    return (0, react_query_1.useInfiniteQuery)(objectiveComparativeKeys_1.default.preset(null, params), ({ pageParam, signal }) => fetchGetUsers(pageParam, signal), {
        getNextPageParam: lastPage => {
            return lastPage?.pagination?.next?.olderThan;
        },
        ...options
    });
};
exports.useGetListUserPreset = useGetListUserPreset;
// ** Will Be Used in Next Release **
const useSharePreset = (id) => {
    return (0, react_query_1.useMutation)(async (body) => {
        const response = await (0, ObjectiveAnalyticsClient_1.shareUsersPreset)(id, body);
        if (response?.isSuccess) {
            return response;
        }
        throw response;
    });
};
exports.useSharePreset = useSharePreset;
const usePatchPreset = (id) => {
    return (0, react_query_1.useMutation)(async (body) => {
        const response = await (0, ObjectiveAnalyticsClient_1.patchPreset)(id, body);
        if (response?.isSuccess) {
            return response;
        }
        throw response;
    });
};
exports.usePatchPreset = usePatchPreset;
const useDeletePreset = (id) => {
    return (0, react_query_1.useMutation)(async (body) => {
        const response = await (0, ObjectiveAnalyticsClient_1.deletePreset)(id, body);
        if (response?.isSuccess) {
            return response;
        }
        throw response;
    });
};
exports.useDeletePreset = useDeletePreset;
